const TRACE_KEY = 'epos:crash-trace';
const MAX_ENTRIES = 300;

type TracePayload = Record<string, unknown>;

const safePayload = (payload?: TracePayload) => {
  if (!payload) {
    return undefined;
  }

  try {
    return JSON.parse(JSON.stringify(payload));
  } catch {
    return { unserializable: true };
  }
};

export const traceCrash = (label: string, payload?: TracePayload) => {
  try {
    const entry = {
      at: new Date().toISOString(),
      t: Date.now(),
      label,
      payload: safePayload(payload),
    };

    const current = JSON.parse(window.localStorage.getItem(TRACE_KEY) ?? '[]') as unknown[];
    current.push(entry);

    window.localStorage.setItem(TRACE_KEY, JSON.stringify(current.slice(-MAX_ENTRIES)));
    console.debug('[EPOS TRACE]', entry);
  } catch {
    // El tracing nunca debe romper la app.
  }
};

const throttleState: Record<string, number> = {};

export const traceCrashThrottled = (
  key: string,
  label: string,
  payload?: TracePayload,
  intervalMs = 1000
) => {
  const now = Date.now();

  if ((throttleState[key] ?? 0) + intervalMs > now) {
    return;
  }

  throttleState[key] = now;
  traceCrash(label, payload);
};

export const clearCrashTrace = () => {
  window.localStorage.removeItem(TRACE_KEY);
};

export const getCrashTrace = () => {
  return JSON.parse(window.localStorage.getItem(TRACE_KEY) ?? '[]');
};

window.addEventListener('error', (event) => {
  traceCrash('window.error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error?.message,
    stack: event.error?.stack,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  traceCrash('window.unhandledrejection', {
    reason:
      event.reason instanceof Error
        ? {
            message: event.reason.message,
            stack: event.reason.stack,
          }
        : String(event.reason),
  });
});
